import { useState, useEffect, useRef } from 'react';
import styles from './FJRecorderDelay.module.less';
import FJLocalStore from '../../../../store/FJLocalStore';

const FJRecorderDelay = props => {
    const { clickStopRecord, onCountDownEnd } = props;
    const [count, setCount] = useState(3);
    const timeoutRef = useRef(null);
    const countDown = useRef(3);

    useEffect(() => {
        timeoutRef.current = setInterval(() => {
            if (countDown.current > 1) {
                countDown.current = countDown.current - 1;
                setCount(countDown.current);
            } else {
                clearInterval(timeoutRef.current);
                timeoutRef.current = null;
                onCountDownEnd();
            }
        }, 1000);
        return () => {
            clearInterval(timeoutRef.current);
            timeoutRef.current = null;
        };
    }, []);

    const onStopRecordClick = () => {
        if (timeoutRef.current) {
            clearInterval(timeoutRef.current);
            timeoutRef.current = null;
        }
        clickStopRecord();
    };

    return (
        <div className={styles.record_delayed_box} onClick={onStopRecordClick}>
            <div className={styles.record_delayed_mask} />
            <div className={styles.record_delayed_content_container}>
                <div className={styles.record_content_max_box} />
                <div className={styles.record_content_medium_box} />
                <div className={styles.record_content_small_box} />
                <div className={styles.record_content_time_text}>{count}</div>
                <div className={styles.record_content_message}>{FJLocalStore._('click-here-to-stop-recording')}</div>
            </div>
        </div>
    );
};

export default FJRecorderDelay;
